// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"html5"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M3 2H21L20 19.5L12 22.5L4 19.5L3 2Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M3 2H21L20 19.5L12 22.5L4 19.5L3 2Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M16.5 6H17.2714L17.2709 6.00771L16.5 6ZM16.5 6H6.72852L7.03576 11.3768L11.2549 11.3768L16.9641 11.3768L16.6569 16.7537L12 18.5L7.34301 16.7536L7.2662 15.4094L7.2566 15.2414M7.2566 15.2414L7.24699 15.0734H7.25L7.2566 15.2414Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Html5Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'html5',
    ref,
    icon: element,
  },
));

Html5Icon.displayName = 'Html5Icon';

export default Html5Icon;
